import cn from 'classnames'
import { NeonCrystal } from 'shared/ui/neon'
import styles from '../neon-wallets.module.scss'

const CRYSTAL_SIZE = 140

/** The Bull's Eye corner crystals, smaller, behind the dialog content. */
export const DialogDecorations: React.FC = () => (
  <div
    className={styles.decorations}
    aria-hidden
  >
    <NeonCrystal
      color='purple'
      size={CRYSTAL_SIZE}
      flip
      className={cn(styles.crystal, styles.crystalTop)}
    />
    <NeonCrystal
      color='green'
      size={CRYSTAL_SIZE}
      className={cn(styles.crystal, styles.crystalBottom)}
    />
  </div>
)
